import { CHECKOUT_COMPLETED } from '~/generated/AnalyticsTypes';
import useAnalytics from '~/react-hooks/use-analytics';
import { useEffect } from 'react';
import useSyncBilling from './use-sync-billing';

export interface UsePlandalfCheckoutSuccessProps {
  onCheckoutSuccess?: () => void;
}

export default function usePlandalfCheckoutSuccess({
  onCheckoutSuccess,
}: UsePlandalfCheckoutSuccessProps) {
  const analytics = useAnalytics();
  const { syncBilling } = useSyncBilling();

  useEffect(() => {
    console.log('plandalfxbonjoro !window.plandalf', !window.plandalf);
    if (!window.plandalf) return;

    const checkoutSuccessHandler = async () => {
      console.log('plandalfxbonjoro checkout-success from plandalf called');

      onCheckoutSuccess?.();

      // TODO: Apply the plan-related context on tracking when checkout completes
      analytics.track(CHECKOUT_COMPLETED, {
        context: 'plandalf_checkout_completed',
      });

      await syncBilling();
    };

    console.log('plandalfxbonjoro checkout-success listener');
    window.plandalf.on('checkout-success', checkoutSuccessHandler);

    return () => {
      window.plandalf.removeListener(
        'checkout-success',
        checkoutSuccessHandler
      );
    };
  }, [window.plandalf]);
}
